<template>
    <div class="login login_bg">
        <div class="container-fluid">
            <div class="row no-gutter">
                <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
                <div class="col-md-8 col-lg-6">
                    <div class="login d-flex align-items-center">
                        <div class="container " style="width: 550px;">
                            <div class="py-5">
                                <div class="col-md-9 col-lg-8 mx-auto ">
                                    <!-- <img :src="require('@/assets/img/bg/bg_login.jpg')" /> -->
                                    <!-- <h3 class="login-heading mb-4">KARA DOING</h3> -->
                                    <img :src="require('@/assets/img/bg/logo_kara.png')" class="img-logo" width="60%"/>
                                    <form>
                                        <div class="form-label-group">
                                            <input v-model="member.email" ref="email" type="email" id="inputEmail"
                                                   class="form-control" placeholder="이메일" required autofocus
                                                   style="padding: 0.75rem 1rem;" @keyup.enter="formSubmit()">
                                            <label for="inputEmail" v-if="!member.email" class="loginLabel">이메일</label>
                                        </div>

                                        <div class="form-label-group">
                                            <input @keyup.enter="formSubmit()" v-model="member.password" ref="password"
                                                   type="password" id="inputPassword" class="form-control"
                                                   placeholder="Password" required
                                                   style="padding: 0.75rem 1rem;">
                                            <label for="inputPassword" v-if="!member.password"
                                                   class="loginLabel">비밀번호</label>
                                        </div>

                                        <div class="custom-control custom-checkbox mb-3">
                                            <input v-model="saveEmail" type="checkbox" class="custom-control-input"
                                                   id="customCheck1">
                                            <label class="custom-control-label" style="font-size:13px;" @click="rememberEmail()"
                                                   for="customCheck1">이메일 기억하기 </label>

                                            <router-link class="small text-basic text-forgotpw" to="/forgotpw"> 비밀번호 찾기
                                            </router-link>
                                            <br/>
                                        </div>

                                        <button v-on:click="formSubmit()"
                                                class="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
                                                type="button">로그인
                                        </button>
                                        <div class="text-center">
                                            <router-link class="small" to="/join" style="font-weight: bold; color:#0077ff;">가입하기
                                            </router-link>
                                            <br/>
                                            <router-link class="small small_txt" to="/forgotemail"> 아이디를 분실했습니다.
                                            </router-link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'login',
        data() {
            return {
                saveEmail: false,
                member: {
                    email: process.env.NODE_ENV == 'development' ? "test@test.com": "",
                    password: process.env.NODE_ENV == 'development' ? "11111111": "",
                },
            };
        },
        methods: {
            formSubmit() {
                if (!this.emailCheck()) return;

                if (process.env.NODE_ENV != 'development') {
                    if (!this.passwordCheck()) return;
                }

                let redirect = this.$auth.redirect();
                let redirectName =  (this.$route.params.ref) ? {path: this.$route.params.ref} : {name: redirect ? redirect.from.name : 'home'};
                let me = this;

                this.$auth.login({
                    data: this.member,
                    rememberMe: this.saveEmail,
                    redirect: redirectName,
                    success: function (res) {
                        if (me.saveEmail)
                            me.$cookies.set('saveEmail', me.member.email);

                        if (me.$auth.user().isWithdraw) {
                            me.$root.$children[0].commonDialog('탈퇴한 회원입니다.');
                            me.$auth.logout();
                            return;
                        }

                    },
                    error: function (res) {
                        me.$root.$children[0].commonDialog('로그인 실패', '로그인에 실패하였습니다. 계정정보를 확인해주세요.');
                    },
                    fetchUser: true,
                });
            },
            emailCheck() {
                let exptext = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;

                if (exptext.test(this.member.email) == false) {
                    alert('이메일 형식이 올바르지 않습니다.');
                    this.$refs.email.focus();
                    return false;
                } else
                    return true;

            },
            passwordCheck() {
                if (this.member.password.length < 8 || this.member.password.length > 15) {
                    alert('비밀번호가 너무 길거나 짧습니다.');
                    this.$refs.password.focus();
                    return false;
                } else
                    return true;
            },
            rememberEmail() {
                if (!!this.saveEmail)
                    this.$cookies.set('saveEmail', "");
            }
        },
        mounted() {
            this.$refs.email.focus();
        },
        created() {

            if (!!this.$cookies.get('saveEmail')) {
                this.saveEmail = true;
                this.member.email = this.$cookies.get('saveEmail');
            } else {
                this.saveEmail = false;
            }

            if(this.$route.params.email) this.member.email = this.$route.params.email;
        },
    };

</script>
<style scoped>


    :root {
        --input-padding-x: 1.5rem;
        --input-padding-y: 0.75rem;
    }

    .login,
    .image {
        min-height: 100vh;
    }

    .bg-image {
        background-image: url('../assets/img/bg/bg_img.jpg');
        background-size: cover;
        background-position: center;
    }

    .img-logo {
        height: 38px;
        width: 146px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        margin-bottom: 55px;
    }

    .login-heading {
        font-weight: normal;
        text-align: center;
        color: #0077ff;
        padding-bottom: 20px;
    }

    .btn-login {
        font-size: 0.9rem;
        letter-spacing: 0.05rem;
        padding: 0.75rem 1rem;
        border-radius: 2rem;
    }

    .form-label-group {
        position: relative;
        margin-bottom: 1rem;
    }

    .form-label-group > input,
    .form-label-group > label {
        padding: var(--input-padding-y) var(--input-padding-x);
        height: auto;
        border-radius: 2rem;
    }

    .form-label-group > label {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        margin-bottom: 0;
        /* Override default `<label>` margin */
        line-height: 1.5;
        color: #495057;
        cursor: text;
        /* Match the input under the label */
        border: 1px solid transparent;
        border-radius: .25rem;
        transition: all .1s ease-in-out;
    }

    .form-label-group input::-webkit-input-placeholder {
        color: transparent;
    }

    .form-label-group input:-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-moz-placeholder {
        color: transparent;
    }

    .form-label-group input::placeholder {
        color: transparent;
    }

    .form-label-group input:not(:placeholder-shown) {
        padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
        padding-bottom: calc(var(--input-padding-y) / 3);
    }

    .form-label-group input:not(:placeholder-shown) ~ label {
        padding-top: calc(var(--input-padding-y) / 3);
        padding-bottom: calc(var(--input-padding-y) / 3);
        font-size: 12px;
        color: #777;
    }


    /* Fallback for Edge
    -------------------------------------------------- */

    @supports (-ms-ime-align: auto) {
        .form-label-group > label {
            display: none;
        }

        .form-label-group input::-ms-input-placeholder {
            color: #777;
        }
    }

    /* Fallback for IE
    -------------------------------------------------- */

    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        .form-label-group > label {
            display: none;
        }

        Email address
        .form-label-group input:-ms-input-placeholder {
            color: #777;
        }
    }

    @media (max-width: 575.98px) {
        .login_bg {
            /* background-image: url(../assets/img/bg/bg_login.jpg); */
            background-size: cover;
            margin-top: -30px;
        }
    }

    .loginLabel {
        top: 10px !important;
        left: 20px !important;
    }

    .text-forgotpw {
        float: right;
        color: #0077ff;
    }

    .small_txt {color: #707070;
    }

</style>